import { isSafeLinkUrl } from './validation';

/** Inline style applied to email links, matching fund_email_base.html. */
const EMAIL_LINK_STYLE = 'color:#4c5464;text-decoration:underline;';

/** Matches markdown links: [text](url). Link text may not contain ']'. */
const MARKDOWN_LINK_PATTERN = /\[([^\]]+)\]\(([^)]+)\)/g;

function escapeHtml(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;');
}

/**
 * Convert a plain-text email body (with optional markdown links) into the HTML
 * body sent to recipients. Escapes all HTML first, so the only tags produced
 * are <br/> and validated <a> tags. Links with an unsafe scheme are left as
 * their escaped literal markdown text.
 */
export function renderEmailBodyHtml(text: string): string {
  const escaped = escapeHtml(text);
  const withLinks = escaped.replace(
    MARKDOWN_LINK_PATTERN,
    (fullMatch, linkText: string, url: string) => {
      if (!isSafeLinkUrl(url)) {
        return fullMatch;
      }
      return `<a href="${url}" style="${EMAIL_LINK_STYLE}">${linkText}</a>`;
    }
  );
  return withLinks.replaceAll('\n', '<br/>');
}
